import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css'; //覆盖浏览器自带的 margin、padding、font-size 等默认样式，避免不同浏览器（如 Chrome、Firefox）的渲染差异。
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
